/* O «+» NO TETO DO STOCK (Proa, 12/10/2026) · sim do Silva. O vigia viu uma cliente a carregar várias vezes no «+» da ficha
   do óleo Avatim: no site só conta o stock de Azeitão (1 unidade), o `maxQty()` da ficha prende a quantidade em 1, e o «+»
   não fazia nada nem dizia nada.
   Agora: no teto, o «+» fica apagado (`aria-disabled`, sem mexer na página, por isso sem saltos) e, se a cliente carregar,
   aparece «Só há N disponível(is)» por baixo da quantidade (ou por cima da barra fixa). O aviso só nasce com o toque: um
   salto que vem de um toque não conta para o CLS.
   ⛔ Não mexe na quantidade nem no carrinho: lê `window.itpMaxQty()` e o `#itpQtyView` da ficha. Sem ficha ITP, não faz nada. */
(function () {
  var MAIS = 'button[onclick="itpQ(1)"], button[onclick="itpSbarQ(1)"]';
  var vista = document.getElementById('itpQtyView');
  if (!vista || typeof window.itpMaxQty !== 'function') return;
  var notaFicha = null, notaBarra = null, apagar = null;

  // 99 é o «sem teto» da ficha (sem stock controlado ou venda contínua); qualquer outro número é o stock real
  // a caixa da ficha escondida = nenhuma variante escolhida (ou esgotada): aí o teto é o da 1.ª variante, que a cliente não
  // escolheu, e o aviso mentia na barra fixa (auditoria A, 12/10)
  var caixa = document.getElementById('itpQtyBox');
  function teto() { if (caixa && caixa.hidden) return 0; try { var m = window.itpMaxQty(); return m > 0 && m !== 99 ? m : 0; } catch (e) { return 0; } }
  function cheio() { var m = teto(); return m > 0 && (parseInt(vista.value, 10) || 1) >= m; }
  function texto(m) { return 'Só há ' + m + (m === 1 ? ' disponível' : ' disponíveis'); }

  var tetoVisto = null;
  function marcar() {
    var c = cheio(), m = teto();
    // o teto mudou (outra variante, ou pack ↔ avulso): um aviso já à vista dizia o número antigo (auditoria B, 12/10)
    if (m !== tetoVisto) { tetoVisto = m; if (notaFicha) notaFicha.hidden = true; if (notaBarra) notaBarra.hidden = true; }
    document.querySelectorAll(MAIS).forEach(function (b) {
      b.classList.toggle('no-teto', c);
      if (c) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    if (!c) { if (notaFicha) notaFicha.hidden = true; if (notaBarra) notaBarra.hidden = true; }
  }

  function nota(naBarra) {
    if (naBarra) {
      if (!notaBarra) {
        var bar = document.getElementById('itpSbar'); if (!bar) return null;
        notaBarra = document.createElement('p'); notaBarra.className = 'qty-teto qty-teto--sbar';
        notaBarra.setAttribute('role', 'status'); bar.appendChild(notaBarra);
      }
      return notaBarra;
    }
    if (!notaFicha) {
      var cta = vista.closest('.qty-cta'); if (!cta) return null;
      notaFicha = document.createElement('p'); notaFicha.className = 'qty-teto';
      notaFicha.setAttribute('role', 'status'); cta.insertAdjacentElement('afterend', notaFicha);
    }
    return notaFicha;
  }

  // em captura: corre ANTES do onclick da ficha, quando a quantidade ainda é a de antes do toque
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(MAIS);
    if (b && cheio()) {
      var naBarra = !!b.closest('.itp-sbar'), p = nota(naBarra);
      if (p) {
        tetoVisto = teto(); p.textContent = texto(tetoVisto); p.hidden = false;
        if (naBarra) { clearTimeout(apagar); apagar = setTimeout(function () { p.hidden = true; }, 3500); }
      }
    }
    setTimeout(marcar, 0);
  }, true);
  document.addEventListener('itpQtyChange', marcar);
  document.addEventListener('change', function () { setTimeout(marcar, 0); });
  marcar();
})();
